import { AbstractControl, ValidatorFn, FormGroup } from '@angular/forms';

export class PasswordValidator {
  static passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const newPassword = control.get('newPassword');
    const confirmPassword = control.get('confirmPassword');

    if (!newPassword || !confirmPassword) {
      return null;
    }

    if (newPassword.value !== confirmPassword.value) {
      return { 'passwordMismatch': true };
    }

    return null;
  }

  static patternValidator(regex: RegExp, validatorOptions: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!control.value) {
        return null;
      }

      if (typeof control.value !== 'string') {
        return { 'invalidType': true };
      }

      if (!regex.test(control.value)) {
        return validatorOptions;
      }

      return null;
    };
  }
}
